/**
 * Extract a column of data with specified map function from data.
 * Each datum in the array is not visual data by default.
 * Specifying identity scale for related channel explicitly will treat them as visual data.
 */
export var Transform = function Transform(_ref) {
  var value = _ref.value;
  return function (data) {
    return data.map(value);
  };
};
Transform.props = {};